var _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgYorBackground2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 300,
    height: 280,
    viewBox: "0 0 383 349",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M478.42 29.4921C478.42 -14.5499 461.53 -56.8448 431.358 -88.3534C401.186 -119.862 360.127 -138.085 316.957 -139.127C273.786 -140.169 231.927 -123.947 200.328 -93.9297C168.729 -63.912 149.895 -22.4793 147.852 21.5133C145.81 65.5059 160.72 108.568 189.396 141.497C218.073 174.426 258.24 194.61 301.315 197.733C344.389 200.857 386.953 186.673 419.909 158.214C452.865 129.754 473.599 89.2765 477.68 45.4317L418.017 39.6552C415.415 67.6109 402.194 93.4196 381.181 111.565C360.168 129.711 333.03 138.755 305.565 136.763C278.101 134.772 252.49 121.903 234.206 100.907C215.921 79.9115 206.415 52.4547 207.717 24.4048C209.02 -3.64508 221.028 -30.0628 241.176 -49.2021C261.324 -68.3415 288.013 -78.6842 315.539 -78.0199C343.065 -77.3555 369.244 -65.7367 388.481 -45.6467C407.719 -25.5567 418.489 1.41077 418.489 29.4921H478.42Z",
    fill: "url(#paint0_linear_312_4919)",
    fillOpacity: 0.12
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M625.821 29.4928C625.821 -53.8039 593.876 -133.797 536.812 -193.389C479.748 -252.981 402.093 -287.446 320.444 -289.417C238.794 -291.387 159.628 -260.708 99.864 -203.935C40.1002 -147.163 4.48002 -68.8009 0.616514 14.4026C-3.24699 97.606 24.9526 179.05 79.1884 241.329C133.424 303.608 209.394 341.78 290.86 347.688C372.327 353.596 452.828 326.77 515.158 272.945C577.488 219.119 616.703 142.563 624.421 59.6395L545.358 51.9848C539.599 113.853 510.342 170.97 463.838 211.128C417.334 251.287 357.274 271.301 296.493 266.893C235.712 262.486 179.032 234.006 138.568 187.541C98.1035 141.075 77.0642 80.311 79.9467 18.2342C82.8292 -43.8426 109.405 -102.307 153.994 -144.664C198.583 -187.021 257.648 -209.911 318.565 -208.44C379.482 -206.97 437.419 -181.257 479.994 -136.796C522.568 -92.3349 546.402 -32.6536 546.402 29.4928H625.821Z",
    fill: "url(#paint1_linear_312_4919)",
    fillOpacity: 0.12
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_312_4919",
    x1: 176.222,
    y1: -23.0492,
    x2: 394.009,
    y2: 197.632,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0843672,
    stopColor: "#D8E6EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B4D8E4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_312_4919",
    x1: 54.2711,
    y1: -69.8787,
    x2: 466.173,
    y2: 347.497,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0843672,
    stopColor: "#D8E6EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B4D8E4"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYorBackground2);
export default __webpack_public_path__ + "static/media/yorBackground2.5f0f85c7967c830859468e879a7c476c.svg";
export { ForwardRef as ReactComponent };